// /src/pages/private/admin/PrivateDocuments/donatePanel/donatePanelCostUtils.js

export function parseAmountLabel(label) {
  if (label == null || label === '') return null;
  const raw = String(label).trim();
  const normalized = raw.replace(/\s/g, '').replace(',', '.');
  const match = normalized.match(/-?\d+(?:\.\d+)?/);
  if (!match) return null;
  const value = Number.parseFloat(match[0]);
  return Number.isFinite(value) ? value : null;
}

export function sumCostRowAmounts(rows) {
  if (!Array.isArray(rows)) return 0;
  return rows.reduce((total, row) => {
    const amount = parseAmountLabel(row?.amountLabel);
    return total + (amount ?? 0);
  }, 0);
}

export function formatEuroAmount(value) {
  if (!Number.isFinite(value)) return '€0.00';
  return `€${value.toFixed(2)}`;
}

export function detectCurrencySymbol(rows) {
  if (!Array.isArray(rows)) return '€';
  const withSymbol = rows.find((row) => String(row?.amountLabel || '').trim());
  if (!withSymbol) return '€';
  const match = String(withSymbol.amountLabel).match(/[€$£]/);
  return match ? match[0] : '€';
}

export function formatTotalLabel(rows) {
  const symbol = detectCurrencySymbol(rows);
  const total = sumCostRowAmounts(rows);
  return `${symbol}${total.toFixed(2)}`;
}

export function computeMonthlyCostAmount(rows) {
  return sumCostRowAmounts(rows) / 12;
}

export function computeYearlyCostAmount(rows) {
  return sumCostRowAmounts(rows);
}

export function formatAmountWithSymbol(rows, value) {
  const symbol = detectCurrencySymbol(rows);
  const safeValue = Number.isFinite(value) ? value : 0;
  return `${symbol}${safeValue.toFixed(2)}`;
}
